import type { BillingPlan, CustomBillingPlan } from '@recruitee/products-types';

import type { PricingFeatureLoadedModel } from '../types/pricing-feature.types';
import { getActiveProductOrThrow } from './get-active-product-or-throw';

export const getAssignedProduct = (
  model: PricingFeatureLoadedModel,
  billingPlans: BillingPlan[] | undefined,
  activeBillingPlan: BillingPlan | undefined,
  activeProduct = getActiveProductOrThrow(model, billingPlans, activeBillingPlan),
  // eslint-disable-next-line max-params-no-constructor/max-params-no-constructor
): CustomBillingPlan | undefined => {
  const assignedProduct = (billingPlans || [])
    .filter(p => filterFn(p, model))
    .sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))
    .shift();

  return activeProduct?.id !== assignedProduct?.id ? <CustomBillingPlan>assignedProduct : undefined;
};

const filterFn = (p: BillingPlan, model: PricingFeatureLoadedModel) => {
  const isAssignedProduct = p.custom;

  if (isAssignedProduct) {
    return model.currencyLock ? p.currency === model.currency : true;
  }

  return false;
};
